module.exports = __webpack_public_path__ + "static/Logo_Colour-c8975615057d0f1eb271e44f6e2703f7.png";